module.exports = __webpack_public_path__ + "static/raizean-logo-100a58a414513ac1efa486596aee3ee1.png";